import { Appwrite } from "appwrite";
import { APP_API_ENDPOINT, APP_PROJECT_ID } from "./config";

const appwrite = new Appwrite();
appwrite.setEndpoint(APP_API_ENDPOINT).setProject(APP_PROJECT_ID);

export { appwrite };
